import {NgModule, APP_INITIALIZER} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {ErrorMessagesModal, HttpErrorInterceptor} from '../infrastructure/interceptors/http-error-interceptor';
import {AuthInterceptor} from '../infrastructure/interceptors/auth.interceptor';
import {ErrorsHandleModule} from '../infrastructure/errors/errors-handler.module';
import { ConfigsLoaderService } from 'app/services/config-loader.service';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';


export function appInitializerFactory(configsLoaderService: ConfigsLoaderService) {
  return () => configsLoaderService.loadConfigs();
}


@NgModule({
  imports: [
    ErrorsHandleModule,
    HttpClientModule,
    FormsModule,
    CommonModule,
    TranslateModule
  ],
  declarations: [ErrorMessagesModal],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [ConfigsLoaderService],
      multi: true
    }
  ],
})
export class CoreModule {
  constructor() {
  }
}
